/** Angular */
import { Injectable, Inject } from '@angular/core';
/** Injections */
import { BYD_HTTP_MOCK_INJECTION_TOKEN } from '../injections/byd-http-mock-injection.token';
/** Interfaces */
import { BydHttpMockInterface } from '../interfaces/byd-http-mock.interface';
/**
 * The api http mock service, is available as an injectable class, contains `injectedHttpMockToken` generic data mock.
 * An BydHttpMockService can be used to inject api mock data token in the application to perform generic http mocking request.
 *
 * @example  constructor(public bydHttpMockService: BydHttpMockService) {
 *            // typed according to a BydHttpMockInterface `BydHttpMockInterface[]`
 *              BydHttpMockService.injectedHttpMockToken
 *            }
 * @example providers: [ // in the generic mock module
 *          BydHttpMockService
 *          {
 *            provide: BYD_HTTP_MOCK_INJECTION_TOKEN,
 *            useValue: [
 *                   {
 *                       url: environment.API_URL/projects,
 *                       body: [{id:1},{id:2}],
 *                   },
 *                  {
 *                       url: environment.API_URL/v1/projects,
 *                       body: [{id:1},{id:2}],
 *                   }
 *              ],
 *             }
 *       ]
 */
// @dynamic
@Injectable({
  providedIn: 'root',
})
export class BydHttpMockService {
  /**
   * Creates an instance of BydHttpMockService.
   *
   * @param injectedHttpMockToken the token used in the dependency injection of this service provider.
   */
  constructor(@Inject(BYD_HTTP_MOCK_INJECTION_TOKEN) public injectedHttpMockToken: BydHttpMockInterface[]) {}
}
